import { Fragment } from 'react'

import { Typography } from '@mui/material'

interface Props {
  rows: string[]
}

export function NotificationContent(props: Props) {
  const { rows } = props

  return (
    <Typography variant="body2">
      {rows.map((item, key) => (
        <Fragment key={key}>
          {item}
          <br />
        </Fragment>
      ))}
    </Typography>
  )
}
